import * as R from 'ramda';
import ReactSVG from 'react-svg';
import SwipeableViews from 'react-swipeable-views';
import React, { useState, useEffect } from 'react';

import './vertical-swipper.scss';

interface VerticalSwiperProps {
  // 需要切换的列表
  list: any[];
  // 当前索引
  current: number;
  // 关闭事件
  onClose: () => void;
  // 占位符函数
  placeholder: (item: any) => React.ReactNode;
  // 准备函数
  onPrepare?: () => Promise<void>;
  // 激活函数, 只有ready, 也就是 准备函数执行成功后才会执行
  onActive: (index: number) => Promise<any>;
  // 成功渲染 以及 成功后的回调
  onSuccessRender: (res: any) => React.ReactNode;
  afterSuccessRender?: (res: any) => void;
  // 失败渲染 以及 失败后的回调
  onFailRender: (res: any) => void;
  afterFailRender?: (res: any) => void;
}

const resolvePromise = () => Promise.resolve();

/**
 * 组件：竖向滑动切换组件
 * 内部逻辑, 当然, 如果不传入 onPrepare 函数, 那么就不会执行 onActive 函数
 *
 * onPrepare(Promise) -> onActive(Promise) ->
 *                       onSuccessRender  -> afterSuccessRender
 *                       onFailRender     -> afterFailRender
 */
export const VerticalSwiper: React.FC<VerticalSwiperProps> = ({
  list,
  current,
  onClose,
  placeholder,
  onSuccessRender,
  afterSuccessRender = R.T,
  onFailRender,
  afterFailRender = R.T,
  onActive,
  onPrepare = resolvePromise,
}) => {
  const [index, setIndex] = useState(current);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(false);

    // 先执行 onPrepare 函数
    onPrepare()
      .then(() => onActive(index))
      .then((res) => {
        if (isMounted) {
          setLoading(false);
          setTimeout(() => afterSuccessRender(res));
        }
      })
      .catch((err) => {
        if (isMounted) {
          setError(true);
          setLoading(false);
          setTimeout(() => afterFailRender(err));
        }
      });

    return () => {
      isMounted = false;
    };
  }, [
    index,
    onActive,
    onPrepare,
    afterSuccessRender,
    onFailRender,
    afterFailRender,
  ]);

  const renderContent = () => {
    if (loading) {
      return placeholder(list[index]);
    }
    if (error) {
      return onFailRender(list[index]);
    }
    return onSuccessRender(list[index]);
  };

  return (
    <div className="vertical-swipper">
      <SwipeableViews
        axis="y"
        index={index}
        onChangeIndex={(ind) => setIndex(ind)}
        onSwitching={(ind, type) => {
          if (type === 'end' && (ind < 0 || ind >= list.length)) {
            setIndex(current);
          }
        }}
        resistance
        containerStyle={{ height: 'var(--vh)', width: '100%' }}
        slideStyle={{ overflow: 'hidden' }}
      >
        {list.map((_, i) => (
          <div key={i} className="swipe-item">
            {/* @ts-ignore */}
            {i === index ? renderContent() : placeholder(list[i])}
          </div>
        ))}
      </SwipeableViews>
      <ReactSVG
        className="close-button"
        src={require('../../svg/video-close.svg')}
        style={{ width: 18, height: 18, padding: `15px` }}
        onClick={onClose}
      />
    </div>
  );
};
